"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportData = void 0;
var _exceljs = _interopRequireDefault(require("exceljs"));
var _fileSaver = require("file-saver");
var _Table = require("./Table.type");
var _ExportOnlyColumn = require("./column/ExportOnlyColumn");
var cleanFileName = function cleanFileName(fileName) {
  return fileName.replace(/ /g, '_');
};
var exportData = function exportData(table, fileName) {
  var exportType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Table.ExportType.CSV;
  var includeColumns = arguments.length > 3 ? arguments[3] : undefined;
  var wb = new _exceljs.default.Workbook();
  var ws = wb.addWorksheet();
  var columns = [];
  var rows = [];
  var showColumn = function showColumn(column) {
    var _column$columnDef$met, _column$columnDef$met2, _column$columnDef$met3;
    return !((_column$columnDef$met = column.columnDef.meta) !== null && _column$columnDef$met !== void 0 && _column$columnDef$met.excludeFromExport) && !!((_column$columnDef$met2 = column.columnDef.meta) !== null && _column$columnDef$met2 !== void 0 && _column$columnDef$met2.header) && (((_column$columnDef$met3 = column.columnDef.meta) === null || _column$columnDef$met3 === void 0 ? void 0 : _column$columnDef$met3.visible) !== false || column.columnDef.id && (includeColumns && includeColumns.includes(column.columnDef.id) || column.columnDef.id.startsWith(_ExportOnlyColumn.EXPORT_ONLY_ID_PREFIX)));
  };
  table.getAllLeafColumns().forEach(function (column) {
    if (showColumn(column)) {
      var _ref = column.columnDef.meta || {},
        exportHeader = _ref.exportHeader,
        header = _ref.header;
      var name = exportHeader || header || '';
      columns.push({
        name: name
      });
    }
  });
  table.getCoreRowModel().rows.forEach(function (row) {
    var rowData = row.getAllCells().filter(function (cell) {
      return showColumn(cell.column);
    }).map(function (cell) {
      var _cell$column$columnDe;
      var rawValue = cell.getValue();
      var exportFormatter = (_cell$column$columnDe = cell.column.columnDef.meta) === null || _cell$column$columnDe === void 0 ? void 0 : _cell$column$columnDe.exportFormatter;
      if (exportFormatter) {
        return exportFormatter(rawValue, row.original);
      } else {
        return rawValue;
      }
    });
    rows.push(rowData);
  });
  ws.addTable({
    name: 'Export',
    ref: 'A1',
    headerRow: true,
    columns: columns,
    rows: rows
  });
  fileName = cleanFileName(fileName);
  if (exportType === _Table.ExportType.EXCEL) {
    wb.xlsx.writeBuffer().then(function (buffer) {
      return (0, _fileSaver.saveAs)(new Blob([buffer]), fileName + '.xlsx');
    });
  } else {
    wb.csv.writeBuffer().then(function (buffer) {
      return (0, _fileSaver.saveAs)(new Blob([buffer]), fileName + '.csv');
    });
  }
};
exports.exportData = exportData;